import { useRouter } from 'next/router';
import { useIsClient } from 'usehooks-ts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useRouteQuery<Query extends Record<string, any>>(): Query {
  const router = useRouter();
  const isClient = useIsClient();
  const query = router.query as Query;
  if (!Object.keys(query).length && isClient) {
    const searchParams = new URLSearchParams(location.search);
    return Array.from(searchParams.entries()).reduce(
      (acc, cur) => ({
        ...acc,
        [cur[0]]: cur[1],
      }),
      {}
    ) as Query;
  }
  return query;
}
